<script>
import moment from 'moment'
import { flatten } from './App';
import { filterPromoChallenges } from './PromoChallengeCards';
import { filterChallengesByType } from './GeneralChallengeCards';
import { variables } from './constants';

export default {
  props: ['initialFilterApplied'],
  watch: {
    initialFilterApplied(newVal) {
      this.onClickFilter();
    }
  },
  methods: {
    onClickFilter: function() {
      this.updateFilterOnStore();

      var challengeList = this.$store.state.modalFilteredChallengeList;
      if (this.$store.state.filters.startingSoon) {
        challengeList = this.applyStartingSoonFilter(challengeList)
      }
      if (this.$store.state.filters.biggestPot) {
        challengeList = this.applyBiggestPotFilter(challengeList)
      }

      this.$store.commit('updateFullFilteredChallengeList', challengeList);
    },
    applyStartingSoonFilter: function(challengeList) {
      return challengeList.filter(function(challenge) {
        var startDate = moment(challenge.start_date);
        var twoWeeksAfter = moment().add(14, 'days');

        return startDate.isSameOrAfter(moment(), 'day') && startDate.isSameOrBefore(twoWeeksAfter, 'day');
      });
    },
    applyBiggestPotFilter: function(challengeList) {
      var promoList = sortedByBiggestPot(filterPromoChallenges(challengeList));
      var teamList = sortedByBiggestPot(filterChallengesByType(challengeList, variables.TEAM));
      var jackpotList = sortedByBiggestPot(filterChallengesByType(challengeList, variables.JACKPOT));
      var stepList = sortedByBiggestPot(filterChallengesByType(challengeList, variables.STEP));
      var sweepstakesList = sortedByBiggestPot(filterChallengesByType(challengeList, variables.SWEEPSTAKES));

      return flatten([promoList, teamList, jackpotList, stepList, sweepstakesList]);
    }
  }
}

function sortedByBiggestPot(list) {
  var aux = Object.assign([], list); // sort method edit the list

  return aux.sort(function(challenge1, challenge2) {
    return getPotValue(challenge1) < getPotValue(challenge2) ? 1 : -1;
  });
}

function getPotValue(challenge) {
  if (challenge.challenge_type.includes(variables.TEAM)) {
    return challenge.prize.first_prize
  } else {
    return challenge.top_price
  }
}
</script>
